<template>
  <div>
    <a :id="`${id}`" class="link-primary" @click="redirectToMap(latitude, longitude)">
      {{ huggedText(address, 40) }}
    </a>
    <b-tooltip
      v-if="address != '' && address != '-' && address.length > 40"
      :target="`${id}`"
      placement="topright"
    >
      <span>{{ address }}</span>
    </b-tooltip>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
export default {
  props: {
    id: {
      type: String,
      required: true,
    },

    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
  },
  mixins: [Helper],
  methods: {
    redirectToMap(lat, long) {
      const url = `https://www.google.com/maps?q=${lat},${long}`
      window.open(url, '_blank')
    },
  },
}
</script>
